let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jjxum")).then(() => parcelRequire('b0xxc'));